export const BUTTON = 'BUTTON';
export const BUTTON_IMG = 'BUTTON_IMG';
export const Chart = 'Chart';
export const DROPDOWN_CHOICE = 'DROPDOWN_CHOICE';
export const DUAL_CHOICE_AND_VALUE = 'DUAL_CHOICE_AND_VALUE';
export const FINISH = 'FINISH';
export const GAINS_AND_LOSSES = 'GAINS_AND_LOSSES';
export const KENNTNISS_CHOICE = 'KENNTNISS_CHOICE';
export const MULTI_CHOICE = 'MULTI_CHOICE';
export const MULTI_CHOICE_CHECK = 'MULTI_CHOICE_CHECK';
export const MULTI_CHOICE_CHECK_OTHER = 'MULTI_CHOICE_CHECK_OTHER';
export const MULTI_CHOICE_OTHER = 'MULTI_CHOICE_OTHER';
export const MULTI_CHOICE_RADIO_OTHER = 'MULTI_CHOICE_RADIO_OTHER';
export const MULTI_ITEM_CHOICESCONTROLLED = 'MULTI_ITEM_CHOICESCONTROLLED';
export const I_CHOICE = 'I_CHOICE';
export const I_CHOICE_SEQ = 'I_CHOICE_SEQ';
export const INPUT = 'INPUT';
export const INPUT_NUM = 'INPUT_NUM';
export const INTERACTION_CHOICE = 'INTERACTION_CHOICE';
export const INTERMEDIATE_RESULT = 'INTERMEDIATE_RESULT';
export const ORDER_CHOICE = 'ORDER_CHOICE';
export const OT_RESULT = 'OT_RESULT';
export const OUTCOME_TASK = 'OUTCOME_TASK';
export const SINGLE_CHOICE = 'SINGLE_CHOICE';
export const SLIDER = 'SLIDER';
export const SLIDER_IMG = 'SLIDER_IMG';
export const SLIDER_CHOICE = 'SLIDER_CHOICE';
export const STACK_SORT = 'STACK_SORT';
export const TEXT = 'TEXT';
export const TEXT2 = 'TEXT2';
export const TEXT_INPUT = 'TEXT_INPUT';
export const TEXT_INPUT_GDPR = 'TEXT_INPUT_GDPR';
export const IAT_TASK = 'IAT_TASK';
export const MATRIX_CHOICE = 'MATRIX_CHOICE';
export const MATRIX_CHOICE_OTHER = 'MATRIX_CHOICE_OTHER';
export const DISCRETE_SLIDER_MANY = 'DISCRETE_SLIDER_MANY';
export const DROPDOWN_TEXT_COUNTRY = 'DROPDOWN_TEXT_COUNTRY';
export const DROPDOWN_TEXT_YEAR = 'DROPDOWN_TEXT_YEAR';
export const EMAIL_CHECKBOX = 'EMAIL_CHECKBOX';
